import { cn } from "@/lib/utils";
import { Calendar } from "lucide-react";
import Image from "next/image";
import Space from "@/app/Components/Element_Components/space/Space";
import { Badge } from "@/app/Components/Element_Components/badge/Badge";
import { Clock } from 'lucide-react';

interface NewsCardProps {
  href: string;
  featuredImage: string;
  title: string;
  category: string;
  publishDate: string;
  className?: string;
}

export const NewsCard = ({ href,featuredImage, title, category, publishDate, className }: NewsCardProps) => {
  // const publishDateObj = new Date(`${publishDate}`);
  // const dateFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' } as const;
  console.log(publishDate)
  const publishDateFormatted = publishDate
  return (
    <a href={href}>
      <div
        className={cn(
          "flex flex-col items-center md:items-start rounded-lg bg-white group cursor-pointer",
          className
        )}
      >
        {/* Featured Image */}
        <img
          src={featuredImage}
          alt='img'
          width={320}
          height={240}
          className="mb-4 rounded-lg object-cover w-full h-48 group-hover:scale-110 transition-transform duration-300 ease-in-out"
        />

        {/* Category and Publish Date */}
        <div className="mb-2 text-sm items-center text-gray-600">
          <Space size={12}>
            <Badge className="bg-[#002B4E]">{category?.toUpperCase()}</Badge>
            <Space align="center">
              <span className='text-sm'><Clock className='p-1'/></span>
              <span className="fw-light">{publishDateFormatted}</span>
            </Space>
          </Space>
        </div>

        {/* Title */}
        <h3 className="mb-2 text-sm group-hover:underline">{title}</h3>

      </div>
    </a>
  );
};
